<template>
  <!-- 聊天内容 -->
  <div
    :id="'chatwindow' + data.uid"
    class="fixedchatwindow"
    :style="{ bottom: curItem.show ? '370px' : '-10px' }"
  >
    <!-- 聊天窗口 -->
    <div class="flexbox-c fixedchatcontent">
      <div class="flexbox fixedchatcontentbody">
        <!-- 头部 -->
        <div
          class="flexbox chatheader"
          :style="{ height: curItem.show ? '40px' : '20px' }"
          @click="tooglewindow(curItem.uid)"
        >
          <div class="userheader" v-show="curItem.show" @click.stop="todetail">
            <img :src="imgurl + curItem.avatar" />
            <i
              v-if="+curItem.vip != 0 && curItem.show"
              class="iconfont icon-V vip"
              :style="{ color: +curItem.vip == 1 ? 'silver' : 'gold' }"
            ></i>
          </div>
          <div class="flexbox username">
            <span
              class="online"
              :style="{
                backgroundColor: curItem.is_online == 1 ? '#9f9' : '#999',
              }"
            ></span>

            {{ curItem.nickname || curItem.username }}
          </div>
          <div class="flexbox optionbox">
            <i
              class="close toogle"
              :class="{
                'el-icon-arrow-down': curItem.show,
                'el-icon-arrow-up': !curItem.show,
              }"
              @click.stop="tooglewindow(curItem.uid)"
            ></i>
            <i
              class="el-icon-close close"
              @click.stop="closewindow(curItem.uid)"
            ></i>
          </div>
        </div>
        <!-- 聊天内容 -->
        <chat-connection-status />
        <div class="desktop-chat-history" :aria-busy="desktopInitialLoading">
          <el-scrollbar ref="scrollbarRef" noresize @scroll="chatwindowscrollevent"
            :style="{ visibility: desktopMessagesVisible ? 'visible' : 'hidden' }">
            <div class="flexbox history" @click="queryHistory">
              {{ historyLabel }}
            </div>

            <div class="flexbox chatbody" v-if="curItem">
              <chat-content
                v-for="item of messages"
                :key="item.client_msg_id || item.id"
                :data="item"
                :data-chat-message-id="item.client_msg_id || item.id"
                @image-load="handleImageLoad"
              />
            </div>
          </el-scrollbar>
        </div>

        <!-- 输入框 -->
        <div class="flexbox-s chatinputbox" v-if="true">
          <el-input v-model="chatcontent" @keydown.enter="send"></el-input>
          <div class="flexbox opratebox">
            <!-- 翻译按钮 -->
            <!-- <div class="flexbox iconbox" @click.stop="showtrans = true">
              <i class="iconfont icon-zhuanhuan" style="font-size: 20px"></i>
            </div> -->
            <!-- 图片按钮 -->
            <div class="flexbox iconbox" @click="$refs.fileinput.click()">
              <i class="iconfont icon-tupian" style="font-size: 20px"></i>
            </div>
            <!-- 图片文件 -->
            <input
              type="file"
              accept="image/*"
              v-show="false"
              @change="fileChange"
              ref="fileinput"
            />
            <!-- 表情按钮 -->
            <div class="flexbox iconbox" @click.stop="showexpress = true">
              <i
                class="iconfont icon-biaoqing"
                style="color: #eedd55; font-size: 20px"
              ></i>
            </div>
            <!-- 发送按钮 -->
            <div class="flexbox sendbtn" @click="send">
              {{ $t("global.send") }}
            </div>
          </div>
          <!-- 表情框 -->
          <div class="flexbox expressbox">
            <img
              class="img"
              v-for="(item, index) of expressionStrList"
              :key="index"
              :src="expressionSource[item]"
              @click.stop="pushexp(item)"
              v-show="showexpress"
            />
          </div>
          <!-- 翻译框 -->
          <div class="flexbox transbox" v-show="showtrans" @click.stop>
            <Trans :id="curItem.uid" height="100px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatContent from "../ChatContent.vue"
import ChatConnectionStatus from "../ChatConnectionStatus.vue"
import desktopChatWindow from "../../util/desktopChatWindow";
import Expression from "../Expression.vue"
import Trans from "../Trans.vue"
import { expressionSource, expressionStrList } from "../../util/expression"
export default {
  mixins: [desktopChatWindow],
  props: ['data'],
  data () {
    return {
      showchatwindow: false,
      // 输入内容
      chatcontent: '',
      // 表情数据
      expressionStrList,
      expressionSource,
      showexpress: false,

      showtrans: false,
    }
  },
  components: {
    ChatConnectionStatus,
    ChatContent,
    Expression,
    Trans,
  },
  computed: {
    messages() {
      return this.$store.getters.chatMessages(this.curItem.uid);
    },
    curItem () {
      return this.data;
    },
  },
  methods: {
    tooglewindow (id) {
      this.$store.commit('toogleUserFromChatWindowList', id);
    },
    closewindow (id) {
      this.$store.commit('deleteUserFromChatWindowList', id);
    },
    // 发送图片
    fileChange(e) {
      e.preventDefault();
      const files = e.target.files || (e.dataTransfer && e.dataTransfer.files) || [];
      const file = files[0];
      const receiverId = this.curItem.uid;
      e.target.value = "";
      if (!file) return false;
      return this.$store.dispatch("sendChatImage", { file, receiver_id: receiverId });
    },
    // 插入表情
    pushexp (item) {
      this.chatcontent += "[" + item + "]";
    },
    // 发送聊天信息
    async send() {
      const text = this.chatcontent;
      if (!text.trim()) {
        this.$message.error(this.$t("tips.contentcantempty"));
        return false;
      }
      const sent = await this.$store.dispatch("wssend", {
        opt: 1, uid: this.$store.state.User.id, address: this.curItem.uid,
        txt: text, type: "text", origin: true,
      });
      if (sent && this.chatcontent === text) this.chatcontent = "";
      return sent;
    },

    todetail () {
      this.$router.push('/w/home/user/detail/' + this.data.uid);
    }
  },
  mounted () {
    document.querySelector('#chatwindow' + this.data.uid).onclick = () => {
      this.showexpress = false;
      this.showtrans = false;
    }
  },
  beforeUnmount () {
    document.querySelector('#chatwindow' + this.data.uid).onclick = null;
  },

}
</script>

<style lang="scss" scoped>
$boderColor: rgba(
  $color: #fff,
  $alpha: 0.3,
);
$border: 1px solid $boderColor;
.fixedchatwindow {
  position: relative;
  width: 290px;
  height: 400px;
  background-color: #f1f2f3;
  overflow: hidden;
  transition: bottom 0.1s;
  margin-right: 10px;
  border-radius: 4px 4px 0 0;
}
.fixedchatcontent {
  width: 100%;
  height: 400px;
  .fixedchatcontentbody {
    width: 100%;
    height: 400px;
    flex-direction: column;
    flex-wrap: nowrap;
    .chatheader {
      height: 40px;
      border-bottom: $border;
      padding: 0 15px;
      flex-wrap: nowrap;
      flex-shrink: 0;
      cursor: pointer;
      .userheader {
        position: relative;
        width: 30px;
        height: 30px;
        flex-shrink: 0;
        border-radius: 4px;
        overflow: hidden;
        img {
          width: 30px;
          height: 30px;
          cursor: pointer;
        }
        .vip {
          position: absolute;
          right: 0px;
          bottom: 0px;
          color: gold;
          font-size: 16px;
          cursor: pointer;
        }
      }
      .username {
        font-size: 12px;
        font-weight: bold;
        color: #666;
        justify-content: flex-start;
        padding-left: 10px;
        cursor: pointer;
        .online {
          display: inline-block;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .optionbox {
        width: auto;
        justify-content: flex-end;
        flex-wrap: nowrap;
        .close {
          cursor: pointer;
          margin-left: 10px;
        }
        .toogle {
          display: none;
        }
        .arrow {
          padding-left: 100px;
        }
      }
    }
    .chatheader:hover {
      .toogle {
        display: inline-block;
      }
    }
    .history {
      font-size: 12px;
      color: #999;
      cursor: pointer;
    }
    .chatbody {
      width: 290px;
      height: 100%;
      overflow: auto;
    }
    .chatinputbox {
      height: auto;
      flex-shrink: 0;
      border-top: $border;
      .opratebox {
        justify-content: flex-end;
        padding: 5px;
        .iconbox {
          width: 20px;
          height: 20px;
          cursor: pointer;
          margin-right: 10px;
        }
        .sendbtn {
          width: auto;
          height: 20px;
          padding: 0 5px;
          background-color: $themeColor;
          border-radius: 3px;
          border: 1px solid #333;
          color: #fff;
          cursor: pointer;
          font-size: 12px;
        }
      }
    }
  }
  .expressbox {
    width: 100%;
    height: auto;
    background-color: #fff;
    justify-content: flex-start;
    align-content: flex-start;
    overflow: hidden;
    img {
      width: 15px;
      height: 15px;
      cursor: pointer;
    }
  }
}
.empty {
  color: #333;
  font-size: 12px;
  margin-top: 100px;
}
</style>
